module.exports = __webpack_public_path__ + "img/金融.c520e449.png";